import type { CustomDirection, ResponsiveStyleValue } from './types';

const DIRECTION_MAP = {
  horizontal: 'row',
  vertical: 'column',
} as const;

const VALID_BREAKPOINTS = new Set(['xs', 'sm', 'md', 'lg', 'xl']);

export function toStackDirection(direction: ResponsiveStyleValue<CustomDirection>) {
  if (typeof direction !== 'object' || direction === null) {
    return direction ? DIRECTION_MAP[direction] || direction : undefined;
  }

  // 반응형 direction 객체 처리
  const converted: Record<string, 'row' | 'column'> = {};

  for (const [breakpoint, value] of Object.entries(direction)) {
    if (!VALID_BREAKPOINTS.has(breakpoint)) {
      continue;
    }

    // direction 값 변환
    if (value) {
      const convertedValue = DIRECTION_MAP[value];
      if (convertedValue) {
        converted[breakpoint] = convertedValue;
      }
    }
  }

  return converted;
}
